<template>
  <!-- Hidden field - no visual representation -->
  <input type="hidden" :name="name" :value="modelValue" />
</template>

<script setup lang="ts">
interface Props {
  modelValue?: any
  name?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
  name: ''
})

const emit = defineEmits<{
  'update:modelValue': [value: any]
  'blur': []
}>()

</script>
